import {useFormContext} from 'react-hook-form';
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
} from '@common-web/components/ui/form';
import {Input} from '@common-web/components/ui/input';
import {ContactFields} from '@client/pages/rfc/forms/components/ContactFields';
import {PayrollVendorSelect} from '@client/pages/rfc/forms/components/PayrollVendorSelect';

export function Section125Payroll() {
  const {control, watch} = useFormContext();

  return (
    <div className='space-y-6'>
      <div>
        <ContactFields
          basePath={'section125Form.payrollInfo.contact'}
          titlePrefix={'Internal Payroll Contact (Optional)'}
          copySources={[
            {
              label: 'Payroll Vendor Contact',
              path: 'section125Form.payrollInfo.payrollVendorContact',
            },
          ]}
        />
      </div>
      <div>
        <ContactFields
          basePath={'section125Form.payrollInfo.payrollVendorContact'}
          titlePrefix={'Payroll Vendor Contact (Optional)'}
          copySources={[
            {label: 'Internal Payroll Contact', path: 'section125Form.payrollInfo.contact'},
          ]}
        />
      </div>
      <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
        <PayrollVendorSelect
          vendorPath={'section125Form.payrollInfo.vendor'}
          payrollSystemPath={'section125Form.payrollInfo.system'}
        />
        <FormField
          control={control}
          name={'section125Form.payrollInfo.payrollCompanyId'}
          render={({field}) => (
            <FormItem>
              <FormLabel>Payroll Company ID Number (Optional)</FormLabel>
              <FormControl>
                <Input {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>
    </div>
  );
}
